import { createContext } from 'react';

const messengerContext = createContext({});

export default messengerContext;
